import React from "react";
import { Button } from "../ui/button";
import { Reveal, Overline } from "../common";
import { useLead } from "../LeadDialog";

const TEXAS_MAP =
  "https://static.prod-images.emergentagent.com/jobs/275e45af-08bc-4081-b14d-43e26f1de654/images/611df4077d663e4fcff6d34addb2167a99ca2461bddcf41d2b353b314b1e6a12.jpeg";

const ServiceArea = () => {
  const { openLead } = useLead();
  return (
    <section
      id="service-area"
      className="py-24 md:py-32 bg-white scroll-mt-20"
      data-testid="service-area-section"
    >
      <div className="max-w-[88rem] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <Overline className="mb-5">Service Area</Overline>
          <h2 className="font-display font-semibold text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-jet-ink">
            Proudly Serving the Dallas/Fort Worth area.
          </h2>

          <Button
            onClick={() => openLead("quote")}
            className="mt-8 rounded-full bg-jet-teal hover:bg-jet-teal-deep text-white font-bold h-14 px-8 teal-glow"
            data-testid="service-area-cta"
          >
            Check Availability in Your Area
          </Button>
        </Reveal>

        <Reveal delay={0.15}>
          <div
            className="relative rounded-3xl overflow-hidden shadow-xl border border-border bg-white p-8 md:p-12"
            data-testid="service-area-map"
          >
            <img
              src={TEXAS_MAP}
              alt="Map of Texas with a marker over the Dallas–Fort Worth service area"
              className="w-full max-w-md mx-auto h-auto object-contain"
              loading="lazy"
            />
            <div className="text-center mt-4">
              <div className="font-display text-2xl md:text-3xl font-semibold text-jet-ink">
                Dallas/Fort Worth, Texas
              </div>
              <div className="text-jet-ink/50 text-sm font-bold uppercase tracking-[0.18em] mt-1">
                Our Primary Service Area
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ServiceArea;
